import React, {Suspense} from 'react';
import { Helmet } from 'react-helmet';
import {Skills} from "./PagesLazyLoad";
import {ScrollToTop} from "@florian-cassagne/simple-toolbox";
import {APP_AUTHOR_NAME_FULL} from "../constants/AppConstants";
import {useTranslation} from "react-i18next";
import LoadingSpinner from "../components/_AppElements/LoadingSpinner";

function Homepage() {
  const { t} = useTranslation();

  return (
    <>
      <Helmet>
        <title>{`${t('page.skills.meta.title')} - ${APP_AUTHOR_NAME_FULL}`}</title>
        <meta name="description" content={t('page.skills.meta.description')}/>
      </Helmet>
      <ScrollToTop/>
      <Suspense fallback={<LoadingSpinner/>}>
        <Skills/>
      </Suspense>
    </>
  );
}


export default Homepage;
